import Param from '../../param';
import axios from 'axios';

const param = new Param();

export default class GoogleMapManager {
    constructor(pageID){
        
        if(pageID === 'top'){
            this.id = "p-stationmap-googlemap";
            this.ICON_ORANGE = "./assets/img/company/b-map_pin_01.png";
            this.ICON_GREEN = "./assets/img/company/b-map_pin_02.png";
        }else if(pageID === 'map'){
            this.id = "p-company-map-google";
            this.ICON_ORANGE = "../assets/img/company/b-map_pin_01.png";
            this.ICON_GREEN = "../assets/img/company/b-map_pin_02.png";
        }

        this.port = [];
        this.lat = [];
        this.lng = [];
        // this.ICON_ORANGE = "../assets/img/company/b-map_pin_01.png";
        // this.ICON_GREEN = "../assets/img/company/b-map_pin_02.png";
        this.markerData = [];
        this.marker = [];
        this.maps;
        this.centerLat = 35.70712300000000000;
        this.centerLng = 139.66500500000000000;
        this.portToolTip = [];
        this.searchText = document.getElementById('p-search-text');
        this.searchBtn = document.getElementById('p-search-btn');

        this.option = {
            style : [
                {
                    "featureType": "all",
                    "elementType": "all",
                    "stylers": [
                        {
                            "hue": "#ffcb00"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#171b1d"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.rail",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-86"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.rail",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "hue": "#ff9500"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.rail",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "hue": "#8000ff"
                        }
                    ]
                }
            ],
            map:[]
        };
    }
    init(){
        axios.get(window.location.origin+'/port.json')
        // axios.get('/port.json')
            .then(response => {
                for(let id in response.data){
                    this.port = response.data[id];
                    this.markerData.push(this.port);
                    this.lat.push(this.port.lat);
                    this.lng.push(this.port.lng);
                }
                this.map();
            })
            .catch(err => {
            console.log('err:', err);
            });
    }

    map(){
        this.maps = new google.maps.Map(document.getElementById(this.id),{
            center: {lat:this.centerLat , lng:this.centerLng },
            scrollwheel: false,
            zoom: 16,
            mapTypeControl: false,
            styles: this.option.style
        });

        for(let i=0; i < this.markerData.length; i++){
            let _markerLatLng = new google.maps.LatLng(this.lat[i], this.lng[i]);

            this.marker[i] = new google.maps.Marker({
                number: [i],//マーカーの順番を保存
                company: this.markerData[i]['company'],//企業名を指定
                port: this.markerData[i]['port'],//ポートを指定
                name: this.markerData[i]['name'],//ポートを指定
                site_url: this.markerData[i]['site_url'],//企業URLを指定
                address: this.markerData[i]['address'],//住所を指定
                tel: this.markerData[i]['tel'],//電話番号を指定
                id: this.markerData[i]['id'],//ステーション詳細
                port_photo_path: this.markerData[i]['port_photo_path'],//ステーション写真
                num_bikes_rentalable: this.markerData[i]['num_bikes_rentalable'],//自転車台数
                num_bikes_parkable: this.markerData[i]['num_bikes_parkable'],//駐車可能
                position: _markerLatLng, // マーカーを立てる位置を指定
                map: this.maps, // マーカーを立てる地図を指定
                type: this.markerData[i]['type'], // ステーションタイプ
                description_title: this.markerData[i]['description_title'], // モビリティーの説明タイトル
                description: this.markerData[i]['description'], // モビリティーの説明本文
                external_url: this.markerData[i]['external_url'], // モビリティーサイトURL
                icon: {
                    url: this.markerData[i]['type'] === 'trader' ? this.ICON_ORANGE : this.ICON_GREEN,
                    scaledSize: (Useragnt.pc) ? new google.maps.Size(59*0.9, 80*0.9) : new google.maps.Size(52 * 0.7, 73 * 0.7)
                }
            });


            this.info(i);
        }
        if(this.searchBtn){
            this.searchBtn.addEventListener('click',()=>{
                this.search();
            });
            document.addEventListener('keypress',(e)=>{
                if(e.keyCode == '13'){
                    this.search();
                }
            })
        }
    }

    info(i){
        let _contentString = '<div class="p-info">' +
            '<div class="p-info__inner">' +
            '<div class="p-info__photo" style="background-image:url('+this.markerData[i]['port_icon_path']+');"></div>' +
            '<dl class="p-info__text">' +
            '<dt>'+this.markerData[i]["name"]+'</dt>' +
            '<dd>'+
            '<p class="address">'+this.markerData[i]["address"]+'</p>' +
            '<p>' +
            '<span class="rental">貸出可能 <span class="num">'+this.markerData[i]["num_bikes_rentalable"]+'</span></span>' +
            '<span class="park">&emsp;駐輪可能 <span class="num">'+this.markerData[i]["num_bikes_parkable"]+'</span></span>' +
            '</p>' +
            '</dd>' +
            '</dl>' +
            '</div>' +
            '</div>';

        this.portToolTip[i] = new google.maps.InfoWindow({
            content: _contentString,
            // closeBoxURL:"/assets/map/b-gmp_infobox_close_btn.png"
        });

        this.marker[i].addListener('mouseover',()=>{
            this.portToolTip[i].open(this.maps, this.marker[i]);
        });
        this.marker[i].addListener('mouseout',()=>{
            this.portToolTip[i].close(this.maps, this.marker[i]);
        });
    }

    search(){
        let _geocoder = new google.maps.Geocoder();
        let _address = this.searchText.value;


        _geocoder.geocode({'address': _address}, (results, status)=>{
            if(status === google.maps.GeocoderStatus.OK){
                this.centerLat = results[0].geometry.location.lat();
                this.centerLng = results[0].geometry.location.lng();
                this.map();
            }
        });

    }
}